"use client";

import React from "react";

const WhatAreDentalSealants: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        What Are Dental Sealants?
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        Dental sealants are thin, protective coatings applied to the chewing
        surfaces of your back teeth – typically your molars and premolars. These
        teeth have deep grooves and pits that can trap food particles and bacteria,
        making them difficult to clean with a toothbrush alone. This is where
        dental sealants come in.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        Think of sealants as raincoats for your teeth. They fill in those tiny
        crevices, creating a smooth surface that&#39;s easier to clean and less
        susceptible to decay. By blocking out food debris and bacteria, sealants
        can significantly reduce the risk of cavities and help maintain your oral
        health over time.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        But how do they work? Once applied, dental sealants bond directly with your
        tooth enamel, forming a strong, protective shield. This barrier prevents
        harmful substances from penetrating the enamel and causing damage. In
        essence, dental sealants act as a first line of defense against decay,
        helping to keep your teeth healthy and strong.
      </p>
    </div>
  );
};

export default WhatAreDentalSealants;